import { render, staticRenderFns } from "./PlanTratamientoTemplate.vue?vue&type=template&id=1c62b346&"
import script from "./PlanTratamientoTemplate.vue?vue&type=script&lang=js&"
export * from "./PlanTratamientoTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports